/**
 * 说明列表
 */
import React from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { XInput, XOKButton, XCancelButton } from '@/components/xqxc_ui';
import model from '@/reducers/client/help/instruction/model';
import TableList from './components/TableList';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import { SearchBox, SearchItem } from '@/components/Layout';
import { TableActionType as ta } from '@/util/enum';
import { TableAction as tac } from '../types';

class Main extends React.Component {

    state = {
        title: '',
        pageNum: 1,
        pageSize: 10
    }

    // 查询
    _searchHandle = (useCache) => {
        const { title, pageNum, pageSize } = this.state;
        this.searchCache = {
            title,
            systemType: this.props.curTabID,
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        this.props.getTableSource(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageNum: this.searchCache.pageNum, pageSize: this.searchCache.pageSize }); // 【第3步，缓存查询状态】
    }

    // 重置
    _resetHandle = () => {
        this.setState({ title: '', pageNum: 1, pageSize: 10 }, () => {
            KeepAlive.saveResetFunc(this._searchHandle); // 【第4步：将是否调用重置交给KeepAlive控制】
        });
    }

    // 表格分页
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageNum, pageSize }, () => {
            this._searchHandle('useCache');
        });
    }

    // 表格操作
    _tableAction = (key, type, item) => {
        const { history, curTabID } = this.props;
        switch (type) {
            case ta.edit:
                history.push({ pathname: `/home/client/help/instruction/edit/${key}/${curTabID}` });
                break;
            case tac.title:
                history.push({ pathname: `/home/client/help/instruction/detail/${key}/${curTabID}` });
                break;
        }
    }

    render() {
        const { title } = this.state;
        let { tableSource, curTabID } = this.props;

        return (
            <KeepAlive id={curTabID} render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 【第1步：调用查询接口初始化数据】
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <SearchBox>
                        <SearchItem>
                            <XInput
                                inputStyle={{ width: '200px' }}
                                label='标题'
                                placeholder='请输入'
                                value={title}
                                bindThis={this}
                                bindName='title'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XOKButton
                                style={{ marginLeft: '20px', width: '60px' }}
                                label='查询'
                                onClick={this._searchHandle}
                            />
                            <XCancelButton
                                style={{ marginLeft: '20px', width: '60px' }}
                                label='重置'
                                onClick={this._resetHandle}
                            />
                        </SearchItem>
                    </SearchBox>
                    <TableList renderData={tableSource} tableAction={this._tableAction} paginationChange={this._paginationChange} />
                </div>
            </KeepAlive>
        );
    }
}

Main.propTypes = {
    history: PropTypes.object,
    curTabID: PropTypes.string,

    getTableSource: PropTypes.func,
    tableSource: PropTypes.array
};
const mapStateToProps = (state) => ({
    tableSource: state.help_instruction.tableSource
});

export default connect(mapStateToProps, { ...model.actions })(Main);